import { useState } from 'react'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { rfiContattiApi } from '../services/api'
import toast from 'react-hot-toast'
import { Plus, Trash2 } from 'lucide-react'

interface Contatto {
  id: number
  nome: string
  email?: string
  telefono_whatsapp?: string
  attivo: boolean
}

export default function RfiImpostazioni() {
  const qc = useQueryClient()
  const { data: contatti = [] } = useQuery({
    queryKey: ['rfi-contatti-avviso'],
    queryFn: () => rfiContattiApi.list().then(r => r.data as Contatto[]),
  })
  const [nome, setNome] = useState('')
  const [email, setEmail] = useState('')
  const [whatsapp, setWhatsapp] = useState('')

  const creaMut = useMutation({
    mutationFn: () => rfiContattiApi.create({ nome, email: email || undefined, telefono_whatsapp: whatsapp || undefined }),
    onSuccess: () => {
      toast.success('Contatto aggiunto')
      qc.invalidateQueries({ queryKey: ['rfi-contatti-avviso'] })
      setNome(''); setEmail(''); setWhatsapp('')
    },
    onError: () => toast.error('Serve almeno email o whatsapp'),
  })
  const toggleMut = useMutation({
    mutationFn: (c: Contatto) => rfiContattiApi.update(c.id, { attivo: !c.attivo }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['rfi-contatti-avviso'] }),
  })
  const deleteMut = useMutation({
    mutationFn: (id: number) => rfiContattiApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['rfi-contatti-avviso'] }),
  })

  return (
    <div className="p-4 space-y-4">
      <h1 className="text-lg font-semibold">Impostazioni RFI — Destinatari Rapportini</h1>

      <div className="card p-4 space-y-2">
        <h2 className="font-medium text-sm">Nuovo contatto</h2>
        <div className="flex gap-2">
          <input className="input" placeholder="Nome" value={nome} onChange={e => setNome(e.target.value)} />
          <input className="input" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
          <input className="input" placeholder="WhatsApp (+39...)" value={whatsapp} onChange={e => setWhatsapp(e.target.value)} />
          <button className="btn-primary" disabled={!nome || (!email && !whatsapp)} onClick={() => creaMut.mutate()}>
            <Plus size={14} className="inline mr-1" /> Aggiungi
          </button>
        </div>
      </div>

      <table className="w-full text-sm card">
        <thead>
          <tr className="text-left text-xs text-slate-500 uppercase">
            <th className="p-2">Nome</th>
            <th className="p-2">Email</th>
            <th className="p-2">WhatsApp</th>
            <th className="p-2">Attivo</th>
            <th className="p-2">Azioni</th>
          </tr>
        </thead>
        <tbody>
          {contatti.map(c => (
            <tr key={c.id} className="border-t">
              <td className="p-2">{c.nome}</td>
              <td className="p-2">{c.email || '—'}</td>
              <td className="p-2">{c.telefono_whatsapp || '—'}</td>
              <td className="p-2">
                <input type="checkbox" checked={c.attivo} onChange={() => toggleMut.mutate(c)} />
              </td>
              <td className="p-2">
                <button className="btn-ghost" onClick={() => deleteMut.mutate(c.id)}><Trash2 size={14} /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
